export default __webpack_public_path__ + "static/media/58.dd5dfe79.jpeg";